import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import actions from './actions'

import userStore from '../../modules/store/modules/user'
import resStore from '../../modules/store/modules/res'
import payStore from '../../modules/store/modules/pay'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
		user: userStore,
		res: resStore,
		pay: payStore
	},
    state: {
		gotUserInfo: false,
		userData: {},
		userInfo: {},
		audioPlay: false
	},
    getters: {},
    mutations, 
    actions
});